export const enrichLocationOptions = (options, location = {}) => {
  if (options?.length && location?.id && !options.map(({ id }) => id).includes(location.id)) {
    return options.concat({ ...location }).sort((a, b) => a.id > b.id);
  } else return options;
};

export const getSublocations = (locationList, locationId) =>
  locationList?.find(({ id }) => id === locationId)?.sublocations || [];
